import tabId from 'services/tabId';
import { ProfileData } from 'store/modules/profile_store/types';

const SITUACOES_LIBERADAS = ['Ativa', 'Em Analise'];

export interface BloqueioAssinatura {
  bloqueada: boolean;
  paralisada: boolean;
  representada: boolean;
}

// Mesma regra da Análise de Mercado: assinatura vencida ou paralisada bloqueia a
// ferramenta; o consultor vê a situação da empresa que está representando.
export const bloqueioDaAssinatura = (profile: ProfileData): BloqueioAssinatura => {
  if (profile.representant) {
    const atual = profile.currentCompany ? profile.currentCompany[tabId()] : undefined;
    const empresa = (profile.represented || []).find((c) => c.id === atual);
    if (empresa && empresa.id !== profile.clientId) {
      return {
        bloqueada:
          SITUACOES_LIBERADAS.indexOf(empresa.sale_situation_name) < 0 ||
          Boolean(empresa.paralisado),
        paralisada: Boolean(empresa.paralisado),
        representada: true,
      };
    }
  }
  return {
    bloqueada:
      SITUACOES_LIBERADAS.indexOf(profile.sale_situation) < 0 || Boolean(profile.paralyzed),
    paralisada: Boolean(profile.paralyzed),
    representada: false,
  };
};
